export enum RealtimeManagerEvent {
  cursor = 'cursor',
  ready = 'ready',
  synced = 'synced',
  change = 'change',
  presence = 'presence'
}
